export default __webpack_public_path__ + "static/media/logo-clickHogar.dc6aa0a0.png";